import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";
import { useT } from "@/lib/i18n";

export function CopyResultButton({ text }: { text: string }) {
  const { t } = useT();
  const [copied, setCopied] = useState(false);

  const onClick = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      toast.success(t("common.copied"));
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("Copy failed");
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={t("common.copy")}
      className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-border bg-background transition hover:border-accent hover:text-accent"
    >
      {copied ? <Check size={16} className="text-accent" /> : <Copy size={16} />}
    </button>
  );
}
